import { createFileRoute, redirect } from "@tanstack/react-router"

import { LINKS } from "../../../../routing/links"

export const Route = createFileRoute("/$sessionId/_session/extra-equipment/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: LINKS.extraEquipmentSelect(params.sessionId) })
  },
})
